import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@services/auth.service';

export const loginGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const user = await auth.get();
    if (user?.type === 'GLOBAL' && Object.keys(user.organizationData ?? {}).length) {
        return true;
    }
    auth.redirectToLogin();
    return false;
};
